import {log} from 'fp-ts/lib/Console';
import {constant, identity} from 'fp-ts/lib/function';
import * as IO from 'fp-ts/lib/IO';
import {pipe} from 'fp-ts/lib/pipeable';

export const NoOp: IO.IO<void> = () => {};

export const emptyIterator = (function*(): IterableIterator<unknown> {})();
export const doNothing = () => NoOp;
export const returnNoOp = identity(NoOp);

export const logWithoutAffectingIO = <T>(getLogMessage: (data: T) => string) => (value: T): IO.IO<T> =>
  pipe(
    getLogMessage(value),
    log,
    constant(IO.of(value))
  );
export const setTimeoutIO = (func: () => unknown) => (milliseconds: number) => () => setTimeout(func, milliseconds);
export const runAndDiscardResult = <T>(operation: IO.IO<T>) => () => {
  operation();
};
